import { render, staticRenderFns } from "./DetailTableForm.vue?vue&type=template&id=708c11de"
import script from "./DetailTableForm.vue?vue&type=script&lang=js"
export * from "./DetailTableForm.vue?vue&type=script&lang=js"
import style0 from "./DetailTableForm.vue?vue&type=style&index=0&id=708c11de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports